import(/* webpackMode: "eager", webpackExports: ["CalendarPage"] */ "/workspace/.ci/web-hosting-src/platform/calendar/CalendarPage.tsx");
